module.exports = __webpack_public_path__ + "img/new_design.f2a9dc75.svg";